export default {
  locale: "ru",
  invalid_rrule:
    "Вы предоставили компоненту недопустимое значение RRule. '% {value}' не является правильной строкой RRule.",
  months: {
    jan: "Янв",
    feb: "Фев",
    mar: "Мар",
    apr: "Апр",
    may: "Май",
    jun: "Июн",
    jul: "Июл",
    aug: "Авг",
    sep: "Сен",
    oct: "Окт",
    nov: "Нов",
    dec: "Дек",
  },
  days_short: {
    mon: "Пн",
    tue: "Вт",
    wed: "Ср",
    thu: "Чт",
    fri: "Пт",
    sat: "Сб",
    sun: "Вс",
    day: "День",
    weekday: "День недели",
    "weekend day": "Выходной день",
  },
  days: {
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Черверг",
    friday: "Пятница",
    saturday: "Суббота",
    sunday: "Воскресенье",
    day: "День",
    weekday: "День недели",
    "weekend day": "Выходной день",
  },
  numerals: {
    first: "Первый",
    second: "Второй",
    third: "Третий",
    fourth: "Четвертый",
    fifth: "Пятый",
    sixth: "Шестой",
    last: "Последний",
  },
  start: {
    label: "Начало",
    tooltip: "Выбор даты и времени для начала по дате",
  },
  repeat: {
    label: "Повторять",
    yearly: {
      label: "Ежегодно",
      on: "каждое",
      on_the: "каждый",
      of: "",
    },
    monthly: {
      label: "Ежемесячно",
      every: "каждый",
      months: "месяц",
      on_day: "день",
      on_the: "каждый",
    },
    weekly: {
      label: "Еженедельно",
      every: "каждую",
      weeks: "неделю",
    },
    daily: {
      label: "Ежедневно",
      every: "каждый",
      days: "день",
    },
    hourly: {
      label: "Ежечасно",
      every: "каждый",
      hours: "час",
    },
  },
  end: {
    label: "Окончание",
    tooltip: "Выбор даты и времени для окончания по дате",
    never: "Никогда",
    after: "После",
    on_date: "Выбор даты",
    executions: "выполнения(ий).",
  },
};
